module.exports = __webpack_public_path__ + "img/小狐狸.612691f7.gif";